import React from "react";

const WalletIcon = (props: any) => {
  const { _className, strokeColor, ...svgProps } = props;
  return (
    <svg width={18} height={18} fill="none" {...svgProps}>
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M16.5 9v3.75c0 2.25-1.5 3.75-3.75 3.75h-7.5C3 16.5 1.5 15 1.5 12.75V9c0-2.04 1.23-3.465 3.143-3.705.195-.03.397-.045.607-.045h7.5c.195 0 .383.007.563.037C15.246 5.512 16.5 6.945 16.5 9Z"
      />
      <path
        stroke="var(--color-blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M13.314 5.287a3.43 3.43 0 0 0-.563-.037h-7.5c-.21 0-.412.015-.607.045.105-.21.255-.405.435-.585l2.437-2.445a2.644 2.644 0 0 1 3.72 0l1.313 1.328a2.53 2.53 0 0 1 .765 1.694ZM16.5 9.375h-2.25c-.825 0-1.5.675-1.5 1.5s.675 1.5 1.5 1.5h2.25"
      />
    </svg>
  );
};

export default WalletIcon;
